export default __webpack_public_path__ + "assets/icon-dumb_seagull.svg";